import { query } from "./strapi";

/**
 * Finalize checkout for selected groups.
 * @param cartId - The cart ID associated with the cart.
 * @param groupIds - Array of group IDs for checkout.
 * @param orderDetails - Order details including payment method and other information.
 */
export async function finalizeCartCheckout(
  cartId: string,
  groupIds: string[],
  orderDetails: Record<string, any>
) {
  return query(`orders/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",

      "x-cart-id": cartId,
    },
    body: JSON.stringify({
      receiverInfo: orderDetails.receiverInfo,
      customerInfo: orderDetails.customerInfo,
      billingInfo: orderDetails.billingInfo,
      userAddress: orderDetails.userAddress,
      groupIds,
    }),
  })
    .then((res) => res || { message: "Checkout successful" })
    .catch((err) => {
      console.error("❌ Error finalizing checkout:", err);
      return { error: "Failed to finalize checkout" };
    });
}
